export { default as GDMTableMobile } from './GDMTableMobile';
